import privateHttpClient from '../privateHttpClient';
import { urlHttpGov } from '../../urls';
import { ISupport } from '../../../pages/Support/interfaces';
import SupportMapper from '../mappers/SupportMapper';

class SupportService {
    private baseURL: string = `${urlHttpGov}/panel/support`;

    async listSupportMessages({ cityId, origin, signal }: { cityId: number, signal: AbortSignal, origin?: string }): Promise<ISupport[]> {
        const { data } = await privateHttpClient.get(`${this.baseURL}/county_id/${cityId}${origin ? `/origin/${origin}` : ''}`, { signal });

        return data.map((contact: any) => SupportMapper.toDomain(contact));
    }

    async getSupportById(id: number, signal: AbortSignal): Promise<ISupport> {
        const { data } = await privateHttpClient.get(`${this.baseURL}/${id}`, { signal });

        return SupportMapper.toDomain(data);
    }

    async updateStatusSupport(id: number, status: string, observation?: string) {
        const { data } = await privateHttpClient.put(`${this.baseURL}/${id}`, {
            status,
            observation: observation !== undefined ? observation : undefined,
        });

        return SupportMapper.toDomain(data);
    }

    async getTotalSupport({ cityId, origin, signal }: { cityId: number, origin: string, signal: AbortSignal }): Promise<number> {

        const { data } = await privateHttpClient.get(`${this.baseURL}/county_id/${cityId}/origin/${origin}/total`, { signal });

        return data;
    }

    async delete(id: number) {
        return privateHttpClient.delete(`${this.baseURL}/${id}`);
    }

}

// eslint-disable-next-line import/no-anonymous-default-export
export default new SupportService();
